import { CASH_SALE, TXN_STATUS } from "../utilities/constants.js";
import { formatDate } from "../utilities/utils.js";

export const domainDetails = {
  MARKET_SEGMENT: [],
  DEAL_TYPE: [],
  RESULT: [],
  REASON_OF_RESULT: [],
  PAYMENT_METHODS: [],
  COMPETITIVE_BIDS: [],
  DISCOUNT_PROGRAMS: [],
  COMP_MAKE: [],
  CURRENCY_TYPE: [],
  DURATION: [],
  MACHINE_SPEC_SMARTGRADE: [],
  SRCH_AVERAGE_SPREAD: [],
};

export const machines = [];

export const paymentType = {
  monthlyPayment: 0,
  cashDown: 0,
  finRate: 0,
  noOfMonths: 0,
  paymentType: CASH_SALE.title,
  pctAppldtoPurch: 0,
  purchOptAmt: 0,
};

export const transactionRequest = {
  dealerAccountId: "",
  dealerAddress: "",
  dealSource: "Direct Entry",
  createdByUser: "",
  transactions: []
};

export const transactions = {
  customerName: "",
  dealMarket: "",
  salePersonID: "",
  salesPersonName: "",
  dealType: "",
  quantity: 1,
  compBids: "1",
  discountPrograms: [],
  txnDate: formatDate(new Date()),
  remarks: "",
  customerPostalCode: "",
  dealKey: "",
  saleReason: "",
  txnStatus: TXN_STATUS.PENDING,
  parentDealerAccountID: "",
  bids: [
    {
      addnlDlrCost: 0,
      bidType: "JD",
      category: "",
      dealerName: "",
      dealResult: "Won",
      dlrMarginPct: 0,
      extAttachCost: 0,
      extAttachDesc: "",
      finBuyDownCost: 0,
      freightPDICost: 0, //Keyspecs array
      machineOrigMDP: 0,
      make: "John Deere",
      model: "",
      pin: "",
      rentalIncome: 0,
      saleAmtPerUnit: "",
      saleReason: "",
      paymentType,
      totDiscountApplied: 0,
      currency: "",
      calcLeasePrice: "",
      calcAdjustMacPrice: "",
      calcNormalizeTp: "",
      calcMachSpread: "",
      calcProgSpread: "",
      calcFinalSpread: "",
      calcFinalSpreadPct: "",
      calcGrossMargin: "",
      calcGrossMarginPct: "",
      machSpecSmartgrade: "N",
      machSpecOther: "N",
    },
    {
      addnlDlrCost: 0,
      bidType: "C1",
      category: "",
      dealerName: "",
      dealResult: "Lost",
      dlrMarginPct: 0,
      extAttachCost: 0,
      extAttachDesc: "",
      finBuyDownCost: 0,
      freightPDICost: 0, //Keyspecs array
      machineOrigMDP: 0,
      make: "",
      model: "",
      pin: "",
      rentalIncome: 0,
      saleAmtPerUnit: "",
      saleReason: "",
      paymentType,
      totDiscountApplied: 0,
      currency: "",
      calcLeasePrice: "",
      calcAdjustMacPrice: "",
      calcNormalizeTp: "",
      calcMachSpread: "",
      calcProgSpread: "",
      calcFinalSpread: "",
      calcFinalSpreadPct: "",
      calcGrossMargin: "",
      calcGrossMarginPct: "",
      machSpecSmartgrade: "N",
      machSpecOther: "N",
    },
  ],
};

export const bids = {
  addnlDlrCost: "",
  bidType: "",
  category: "",
  dealerName: "",
  dealResult: "Won",
  dlrMarginPct: "",
  extAttachCost: "",
  extAttachDesc: "",
  finBuyDownCost: "",
  freightPDICost: "", //Keyspecs array
  machineOrigMDP: "",
  make: "",
  model: "",
  pin: "",
  rentalIncome: "",
  saleAmtPerUnit: "",
  saleReason: "",
  paymentType,
  totDiscountApplied: "",
  currency: "",
  calcLeasePrice: "",
  calcAdjustMacPrice: "",
  calcNormalizeTp: "",
  calcMachSpread: "",
  calcProgSpread: "",
  calcFinalSpread: "",
  calcFinalSpreadPct: "",
  calcGrossMargin: "",
  calcGrossMarginPct: "",
  machSpecSmartgrade: "N",
  machSpecOther: "N",
};

export const businessActivities = null;

export const userDetails = {};

export const dealerAccount = {
  accountId: "",
  group3LeadId: "",
  accounts: [],
};

export const paymentMethod = "";

export const selectedAccordion = "Customer & Deal Information";

export const onSubmitDetails = {
  errorFlag: "false",
  errorFields: [],
};

export const createTransactionResponseObj = null;

export const transactionAttachmentResponse = null;

export const transactionStatus = null;

export const isSimulateMode = false;

export const simulatedBusinessActivities = {};

export const simulatedUserDetails = {};

export const searchTransactionResponse = null;

export const searchTxnAccountDropdowns = {
  storedParentDealerAccountIds: null,
  storedDealerAccountIds: null,
  storedSalesPersonNames: null,
  dealerDataAvailable: false
};
export const actionType = {
  action: "Create",
};

export const searchObj = {
  pageNo: 1,
  rowsPerPage: 10,
  sortBy: "txnId",
  sortOrder: "desc",
};

export const txnsForReviewCount = 0;

export const searchPageComponents = {
  selectedTransactions: [],
  isTableVisible: false,
  selectedTxnStatus: false,
};

export const transactionAttachments = []